module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gb5Dx"))).then(() => parcelRequire('9Lwss'));